import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiSignup } from "../../api/auth";

const SignupForm: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      setError("All fields are required");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (!email.endsWith("@capgemini.com")) {
      setError("Only Capgemini email addresses are accepted (e.g. example@capgemini.com)");
      return;
    }

    setLoading(true);
    try {
      await apiSignup({ name: `${firstName} ${lastName}`, email, password });
      navigate("/login");
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const eyeOpen = (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-gray-600">
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.964 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );

  const eyeClosed = (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-gray-600">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.5a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
    </svg>
  );

  const inputClass = "flex flex-row justify-end items-center p-4 gap-4 isolate w-full h-12 bg-white border-b-2 border-[#1D365A] focus:outline-none focus:border-blue-500";

  return (
    <div className="flex flex-col justify-center w-full lg:w-1/2 px-4 sm:px-6 lg:px-16 py-10 lg:py-20">
      <div className="w-full max-w-md"> 
      <h2 className="text-3xl font-light mb-3">Sign up to access event insights</h2>
      <p className="text-sm text-gray-600 mb-6">Create an account to unlock all event details, schedules, rules, and updates.</p>

      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

      <form className="space-y-4" onSubmit={handleSubmit}>
        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal">First Name*</label>
          <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} className={inputClass} />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal">Last Name*</label>
          <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} className={inputClass} />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal">Email Address*</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal">Password*</label>
          <div className="relative w-full">
            <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} />
            <span onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-3 cursor-pointer">
              {showPassword ? eyeOpen : eyeClosed}
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-normal">Re-enter Password*</label>
          <div className="relative w-full">
            <input type={showRePassword ? "text" : "password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className={inputClass} />
            <span onClick={() => setShowRePassword(!showRePassword)} className="absolute right-4 top-3 cursor-pointer">
              {showRePassword ? eyeOpen : eyeClosed}
            </span>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
         
className="w-full h-14 bg-[#A6ACB5] rounded-full text-gray-700 hover:bg-[#1D365A] hover:text-white transition disabled:opacity-60"
        >

          {loading ? "Signing up..." : "Sign Up"}
        </button>
      </form>
      </div>
    </div>
  );
};

export default SignupForm;
